import Cookies from "js-cookie";
const $ = require("jquery");

$(document).ready(function() {
    var contrast = Cookies.get("contrast");

    /* if user has set high contrast mode, add high contrast classes */
    if (contrast == "high-contrast") {
        toggleHighContrast();
    }

    $(".menu .menu-item-has-children").on("click", function() {
        var a = $(this).find("a");
        var button = $(this).find("button");
        var state = button.attr("aria-expanded");

        if (state == "false") {
            button.attr("aria-expanded", "true");
            a.attr("aria-expanded", "true");
        } else {
            button.attr("aria-expanded", "false");
            a.attr("aria-expanded", "false");
        }
    });

    $(".header__top").on("click", function() {
        var button = $(this).find("button");
        var state = button.attr("aria-expanded");

        if (state == "false") {
            button.attr("aria-expanded", "true");
            button.attr("aria-expanded", "true");
        } else {
            button.attr("aria-expanded", "false");
        }
    });

    $(".header__menu-button").on("click", function() {
        var span = $(this).find("span");
        var state = $(this).attr("aria-expanded");

        if (state == "false") {
            span.text("Sluit");
        } else {
            span.text("Menu");
        }
    });

    $(".menu__switch").on("click", function() {
        var button = $(this).find("button");
        let contrast = Cookies.get("contrast");

        if (contrast != "high-contrast") {
            button.attr("aria-label", "verminder contrast");
            Cookies.set("contrast", "high-contrast");
        } else {
            button.attr("aria-label", "vergroot contrast");
            Cookies.remove("contrast", "high-contrast");
        }

        toggleHighContrast();
    });
});

/* Toggle high contrast mode */
function toggleHighContrast() {
    $(".menu > li a").toggleClass("high-contrast");
    $(".menu > li button").toggleClass("high-contrast");
    $(".field").toggleClass("high-contrast");
    $(".small").toggleClass("high-contrast");
    $(".select__control").toggleClass("high-contrast");
    $(".select__placeholder").toggleClass("high-contrast");
    $(".breadcrumb_last").toggleClass("high-contrast");
    $(".breadcrumbs a").toggleClass("high-contrast");
    $(".searchresults__heading").toggleClass("high-contrast");
    $(".searchresults__title").toggleClass("high-contrast");
    $(".search__button").toggleClass("high-contrast");
    $(".search__input").toggleClass("high-contrast");
    $(".peilers__wrapper__title").toggleClass("high-contrast");
    $(".peilers__text").toggleClass("high-contrast");
    $(".peilers__image__source").toggleClass("high-contrast");
    $(".peilers__title").toggleClass("high-contrast");
    $(".peilers__item").toggleClass("high-contrast");
    $(".image__caption").toggleClass("high-contrast");
    $(".summary__text").toggleClass("high-contrast");
    $(".editor a").toggleClass("high-contrast");
    $(".field__label").toggleClass("high-contrast");
    $("strong").toggleClass("high-contrast");
    $(".select__indicator").toggleClass("high-contrast");
    $(".menu__sub").toggleClass("high-contrast");
    $(".text__content ul").toggleClass("high-contrast");
    $(".text__content h2, .text__content h3, .text__content h4").toggleClass(
        "high-contrast"
    );
    $(".text__content p").toggleClass("high-contrast");
    $(".fullsize_banner--background-default .editor").toggleClass(
        "high-contrast"
    );
    $(".fullsize_banner__content p").toggleClass("high-contrast");
    $(".fullsize_banner--background-graphic .editor").toggleClass(
        "high-contrast"
    );
    $(".banner__text").toggleClass("high-contrast");
    $(".banner").toggleClass("high-contrast");
    $(".text__content ol").toggleClass("high-contrast");
    $(".banner__title").toggleClass("high-contrast");
    $(".fullsize_banner__title").toggleClass("high-contrast");
    $(".fullsize_banner__subtitle").toggleClass("high-contrast");
    $(".quote__quote").toggleClass("high-contrast");
    $(".menu-item-has-children").toggleClass("high-contrast");
    $(".menu__child").toggleClass("high-contrast");
    $(".fullsize_banner--background-gradient .editor").toggleClass(
        "high-contrast"
    );
    $(".button--sticky").toggleClass("high-contrast");
    $(".contact").toggleClass("high-contrast");
    $(".filter__title").toggleClass("high-contrast");
    $(".link").toggleClass("high-contrast");
    $(".buttons").toggleClass("high-contrast");
    $(".button--secondary").toggleClass("high-contrast");
    $(".social-map-root").toggleClass("high-contrast");
    $(".bulletboard__wrapper").toggleClass("high-contrast");
    $(".button--primary").toggleClass("high-contrast");
    $(".organization-archive__control").toggleClass("high-contrast");
    $(".list-faq__title").toggleClass("high-contrast");
    $(".list-faq__content").toggleClass("high-contrast");
    $(
        ".page-header__title, .page-header__subtitle, .page-header__text"
    ).toggleClass("high-contrast");
    $(".fullsize_banner--background-graphic .buttons .button").toggleClass(
        "high-contrast"
    );

    $(".fullsize_banner--background-gradient .buttons .button").toggleClass(
        "high-contrast"
    );
    $(".filter__checkbox-group").toggleClass("high-contrast");
    $(".page-header").toggleClass("high-contrast");
    $(".gallery").toggleClass("high-contrast");
    $(".list__text").toggleClass("high-contrast");
    $(".list__item").toggleClass("high-contrast");
    $(".list__title").toggleClass("high-contrast");
    $(".list__header").toggleClass("high-contrast");
    $(".list__image__caption").toggleClass("high-contrast");
    $(".list__image__caption").toggleClass("high-contrast");
    $(".list__wrapper__title").toggleClass("high-contrast");

    $(".title__title").toggleClass("high-contrast");

    $(".map__title").toggleClass("high-contrast");
    $(".map__text p").toggleClass("high-contrast");

    $(".side-box__box-title a").toggleClass("high-contrast");
    $(".side-box__title").toggleClass("high-contrast");
    $(".side-box__box-title").toggleClass("high-contrast");
    $(".side-box__text").toggleClass("high-contrast");

    $(".footer__copyright").toggleClass("high-contrast");

    $(".socials__link--twitter").toggleClass("high-contrast");
    $(".socials__link--facebook").toggleClass("high-contrast");
    $(".socials__link--instagram").toggleClass("high-contrast");
    $(".socials__link--linkedin").toggleClass("high-contrast");

    $(".gallery__title").toggleClass("high-contrast");
    $(".gallery__text").toggleClass("high-contrast");
    $(".gallery__item .caption--title").toggleClass("high-contrast");

    $(".section__add-organization-link").toggleClass("high-contrast");

    $(".pagination").toggleClass("high-contrast");

    $(".social-map").toggleClass("high-contrast");
    $(".social-map__title").toggleClass("high-contrast");
    $(".social-map__reset").toggleClass("high-contrast");

    $("table").toggleClass("high-contrast");
}
